import styled from 'styled-components'

import { helpers } from 'styles'

export const PointItem = styled.li`
	display: flex;
	column-gap: 16px;
	font-size: ${helpers.font.size.base};
	padding: 0;

	& > * {
		flex: 1;
	}

	& > svg {
		flex: 0 0 auto;
		color: ${helpers.color.icon};
	}
`
